// src/components/home/SyncProblemsSection.js
import React from 'react';
import './SyncProblemsSection.css';

const SyncProblemsSection = () => {
  const scenarios = [
    {
      time: "MONDAY, 9:15 AM",
      title: "The Double Booking",
      subtitle: "Two patients booked for the same time slot",
      timeline: [
        { icon: "1", time: "9:15:00 AM", text: "Sarah books Tuesday 2:00 PM online" },
        { icon: "2", time: "9:16:30 AM", text: "John calls, front desk sees 2:00 PM available in Open Dental" },
        { icon: "3", time: "9:17:00 AM", text: "Front desk books John for Tuesday 2:00 PM" },
        { icon: "⚠️", time: "TUESDAY, 2:00 PM", text: "Both patients show up. Chaos ensues." }
      ],
      resultTitle: "Why This Happened:",
      resultText: "Sarah's booking took 3-5 minutes to sync. During that delay, your Open Dental showed the slot as available."
    },
    {
      time: "WEDNESDAY, 10:30 AM",
      title: "The Emergency Block",
      subtitle: "Patient books a slot you just blocked",
      timeline: [
        { icon: "1", time: "10:31:00 AM", text: "Front desk blocks Thursday 3:00 PM for emergency patient" },
        { icon: "2", time: "10:32:30 AM", text: "Jennifer books Thursday 3:00 PM online (system hasn't synced)" },
        { icon: "⚠️", time: "10:36:00 AM", text: "Front desk must call Jennifer—appointment can't be honored" }
      ],
      resultTitle: "Why This Happened:",
      resultText: "Blocks take 2-5 minutes to sync online. Patients can still book slots that don't exist."
    }
  ];

  return (
    <section className="problems-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-badge-warning">The Hidden Cost</span>
          <h2 className="section-title">Why "Syncs Every Few Minutes" Is a Big Problem</h2>
          <p className="section-subtitle">
            Other systems use software that syncs to Open Dental every 2-5 minutes. Sounds fast? Here's what actually happens in your practice...
          </p>
          <p className="section-explanation">
            (These are real scenarios reported by practices using NexHealth and Weave)
          </p>
        </div>

        <div className="scenarios-grid">
          {scenarios.map((scenario, idx) => (
            <div key={idx} className="scenario-card">
              <div className="scenario-header">
                <div className="scenario-time">{scenario.time}</div>
                <div className="scenario-title">{scenario.title}</div>
                <div className="scenario-subtitle">{scenario.subtitle}</div>
              </div>
              <div className="scenario-body">
                {scenario.timeline.map((item, i) => (
                  <div key={i} className="timeline-item">
                    <div className="timeline-icon">{item.icon}</div>
                    <div className="timeline-content">
                      <div className="timeline-time">{item.time}</div>
                      <div className="timeline-text">{item.text}</div>
                    </div>
                  </div>
                ))}

                <div className="problem-result">
                  <div className="result-title">{scenario.resultTitle}</div>
                  <div className="result-text">{scenario.resultText}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Technical Explanation */}
        <div className="tech-explanation">
          <h3 className="tech-title">The Technical Reality</h3>
          <div className="tech-grid">
            <div className="tech-box">
              <div className="tech-label">❌ NexHealth / Weave</div>
              <ul className="tech-list">
                <li><span className="x-icon">✗</span><span>Software on your server polls every 2-5 min</span></li>
                <li><span className="x-icon">✗</span><span>Chrome extension on every computer</span></li>
                <li><span className="x-icon">✗</span><span>Changes batched and sent periodically</span></li>
                <li><span className="x-icon">✗</span><span>Always 2-5 minute delay minimum</span></li>
              </ul>
            </div>

            <div className="tech-box">
              <div className="tech-label">✓ BookDentist.pro</div>
              <ul className="tech-list">
                <li><span className="check-icon">✓</span><span>Reads Open Dental directly via API</span></li>
                <li><span className="check-icon">✓</span><span>No software on your server</span></li>
                <li><span className="check-icon">✓</span><span>No Chrome extensions needed</span></li>
                <li><span className="check-icon">✓</span><span>Always shows current availability</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SyncProblemsSection;